import React, { FC, useEffect, useState } from 'react';
import { ButtonGroup, Dialog, DialogTitle } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import {
  FormControl,
  Message,
  Icons,
  Paragraph,
  TextFieldAdapter,
  Button,
} from '../../../../shared/components';
import { useFetch } from '../../../../shared/hooks';
import { useParams } from 'react-router';
import apiRoutes from '../../../../../config/api/routes';
import { Field, Form } from 'react-final-form';
import { UrlParams } from '../../../../shared/types';
import { StyledDialogContent } from './Atoms';

type Props = {
  id: string;
  title: string;
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
};

const EditSeriesFormDialog: FC<Props> = ({ id, title, open, onConfirm, onCancel }) => {
  const { t } = useTranslation();
  const { bookId } = useParams<UrlParams>();
  const [patchSeriesResponse, patchSeries] = useFetch(apiRoutes.bookPage(bookId as string, id), {
    method: 'PATCH',
  });

  const [shouldUpdate, setShouldUpdate] = useState(false);

  useEffect(() => {
    if (patchSeriesResponse.success && shouldUpdate) {
      setShouldUpdate(false);
      onConfirm();
    }
  }, [patchSeriesResponse, onConfirm, shouldUpdate]);

  const handleCancelClick = (event: React.MouseEvent) => {
    event.stopPropagation();
    onCancel();
  };

  return (
    <Dialog open={open || false} onClose={onCancel} aria-labelledby={`patchSeries-${id}-dialog`}>
      <DialogTitle>{t('trajectory.sections.exercises.updateSeriesModal.title')}</DialogTitle>
      <StyledDialogContent>
        <Paragraph>{t('trajectory.sections.exercises.updateSeriesModal.description')}</Paragraph>
        <Form
          onSubmit={(values) => {
            setShouldUpdate(true);
            patchSeries({
              body: {
                title: values.title,
              },
            });
          }}
          initialValues={{
            title: title,
          }}
          render={({ handleSubmit }) => (
            <form onSubmit={handleSubmit}>
              <FormControl
                label={t('trajectory.sections.exercises.updateSeriesModal.name')}
                id="title"
              >
                <Field name="title" component={TextFieldAdapter} type="text" />
              </FormControl>
              <ButtonGroup>
                <Button type="submit" icon={Icons.SUBMIT}>
                  {t('shared.save')}
                </Button>
                <Button variant="text" onClick={handleCancelClick}>
                  {t('shared.forms.cancel')}
                </Button>
              </ButtonGroup>
              {patchSeriesResponse && patchSeriesResponse.error && (
                <Message type="error">{t(patchSeriesResponse.reason)}</Message>
              )}
            </form>
          )}
        />
      </StyledDialogContent>
    </Dialog>
  );
};

export default EditSeriesFormDialog;
